// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1hLRB","header":"Messages_header__1oE9K"};